import React from 'react';
import { motion } from 'framer-motion';
import { Users, MapPin, Building2, Sparkles, AlertTriangle, ChevronRight } from 'lucide-react';

export const ComparisonCard = ({ comparison, onExplore }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="bg-white rounded-xl border border-slate-200 p-5 hover:shadow-lg transition-shadow"
    >
      <div className="flex items-start justify-between mb-4">
        <div className="flex items-center gap-2">
          {comparison.comparison_type === 'supervisor' && <Users className="h-5 w-5 text-[#2E5C8A]" />}
          {comparison.comparison_type === 'location' && <MapPin className="h-5 w-5 text-[#FF8C42]" />}
          {comparison.comparison_type === 'department' && <Building2 className="h-5 w-5 text-[#4CAF93]" />}
          <span className="text-sm font-medium text-slate-600 capitalize">{comparison.comparison_type} Comparison</span>
        </div>
        <div className="flex items-center gap-1 text-xs bg-amber-100 text-amber-700 px-2 py-1 rounded-full">
          <Sparkles className="h-3 w-3" />
          AI Suggested
        </div>
      </div>

      <div className="space-y-3">
        <div className="bg-green-50 rounded-lg p-3 border border-green-200">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-green-700 font-medium">{comparison.entity_a.name}</p>
              <p className="text-xs text-green-600">{comparison.entity_a.department}</p>
            </div>
            <div className="text-right">
              <p className="text-lg font-bold text-green-700">{comparison.entity_a.premium_percent.toFixed(1)}%</p>
              <p className="text-xs text-green-600">premium</p>
            </div>
          </div>
          <div className="flex items-center gap-4 mt-2 text-xs text-green-600">
            <span>{comparison.entity_a.employee_count} employees</span>
            <span>{comparison.entity_a.total_hours.toLocaleString()} hrs</span>
          </div>
        </div>

        <div className="flex items-center justify-center">
          <div className="bg-slate-200 px-3 py-1 rounded-full text-xs font-medium text-slate-600">vs</div>
        </div>

        <div className="bg-red-50 rounded-lg p-3 border border-red-200">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-red-700 font-medium">{comparison.entity_b.name}</p>
              <p className="text-xs text-red-600">{comparison.entity_b.department}</p>
            </div>
            <div className="text-right">
              <p className="text-lg font-bold text-red-700">{comparison.entity_b.premium_percent.toFixed(1)}%</p>
              <p className="text-xs text-red-600">premium</p>
            </div>
          </div>
          <div className="flex items-center gap-4 mt-2 text-xs text-red-600">
            <span>{comparison.entity_b.employee_count} employees</span>
            <span>{comparison.entity_b.total_hours.toLocaleString()} hrs</span>
          </div>
        </div>
      </div>

      <div className="mt-4 bg-slate-50 rounded-lg p-3">
        <div className="flex items-center gap-2">
          <AlertTriangle className="h-4 w-4 text-amber-500" />
          <span className="text-sm font-medium text-slate-700">
            {comparison.variance.toFixed(1)} percentage point difference
          </span>
        </div>
        <p className="text-xs text-slate-500 mt-1">{comparison.insight}</p>
      </div>

      <button
        onClick={() => onExplore && onExplore(comparison)}
        data-testid="explore-comparison-btn"
        className="w-full mt-4 flex items-center justify-center gap-2 text-sm text-[#2E5C8A] hover:text-[#1e3a5f] font-medium py-2 rounded-lg hover:bg-[#2E5C8A]/5 transition-colors"
      >
        Explore this comparison
        <ChevronRight className="h-4 w-4" />
      </button>
    </motion.div>
  );
};
